export default __webpack_public_path__ + "static/media/meditating.5da2085e.png";